import React from 'react';
import { APPOINTMENT_STATUS } from '../../utils/constants';

export default function StatusBadge({ status, short = false, className = '' }) {
  const meta = APPOINTMENT_STATUS[status] || { label: status, short: status, tone: 'neutral' };
  return <span className={`badge badge--${meta.tone} ${className}`}>{short ? meta.short : meta.label}</span>;
}
